<template>
  <div>
    <b-card no-body>
      <div class="card-smallHeader card-header-action"
           :aria-expanded="visible ? 'true' : 'false'"
           aria-controls="collapse-pieces-jointes"
           >
        <span><b>Pièces Jointes</b></span>
        <span v-if="dossier.mail">
          <span class="ml-2"><i class="clickable fa fa-1-5x fa-envelope-o text-primary" @click.prevent="showMail" v-b-tooltip.hover title="Voir le mail d'origine"></i></span>
        </span>
        <span v-if="hasMails()" class="ml-2"><i class="clickable fa fa-envelope-o" @click.prevent="showMails" v-b-tooltip.hover title="Voir les mails fusionnés (Retour DPC ou manuel)"></i></span>
        <div class="card-header-actions" v-b-toggle.collapse-pieces-jointes>
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
          <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
        </div>
      </div>
      <b-collapse id="collapse-pieces-jointes" v-model="visible" class="m-3" :class="visible ? null : 'collapsed'">
        <b-row>
          <b-col class="col-lg-6 col-md-12 pj-bloc">
            <h5 class="mb-4">Externe</h5>
            <v-client-table id="table-pj-externe" ref="table-pj-externe" :columns="columns" :data="piecesJointesExterne" :options="options">
              <div slot="afterFilterWrapper">
                <b-button class="pull-right mb-3" type="button" @click="openModal(true)"
                  size="sm" variant="secondary" :hidden="cantEditFicheDC(dossier)">
                  <i class="fa fa-download"></i> Ajouter une pièce jointe
                </b-button>
              </div>
              <div slot="h__is_visible_for_client">
                <i class="fa fa-eye"></i> Clt
              </div>
              <div slot="dossier_id" slot-scope="props">
                <img style="width: 20px;" class="mr-2" :src="getIconSrc(props.row)"> {{ getPjDossierId(props.row) }}
              </div>
              <div slot="date_reception" slot-scope="props">
                {{ shortFormatDate(props.row.date_reception) }}
              </div>
              <div slot="name" slot-scope="props">
                <a v-b-tooltip.hover.left.html :title="getTooltipName(props.row)" :id="`pj_${props.row.id}`" href="#" @click.prevent="download(props.row.id,props.row.name)">
                  <span v-if="props.row.types_pj && props.row.types_pj.length >= 1"> {{ reducedFileName(props.row.name) }}</span>
                  <span v-else :title="props.row.name"> {{ reducedFileName(props.row.name) }}</span>
                </a>
                <!-- <b-tooltip v-if="props.row.types_pj && props.row.types_pj.length > 1" :target="`pj_${props.row.id}`" triggers="hover" v-html="getTooltipName(props.row)">
                  <div v-for="type in props.row.types_pj">
                    {{ type.libelle }} <span v-if="!isEmpty(type.periodes)"> : </span><span v-for="periode in type.periodes">du {{periode.date_debut}} au {{periode.date_fin}}, </span>
                  </div>
                </b-tooltip> -->
                <i v-if="props.row.description" class="fa fa-question-circle ml-2" v-b-tooltip.hover :title="props.row.description"></i>
                <i class="fa fa-pencil ml-2 clickable float-right" v-b-tooltip.hover.left title="Modifier le nom de la pièce jointe" @click="initModifyPj(props.row)" :hidden="cantEditFicheDC(dossier)"></i>
              </div>
              <div slot="categorie" slot-scope="props">
                <span :id="`tooltip-cat-${props.row.id}`">{{ categoriePj[props.row.id].length > 15 ? categoriePj[props.row.id].substring(0,12) + '...' : categoriePj[props.row.id] }}</span>
                <b-tooltip v-if="categoriePj[props.row.id].length > 15" :target="`tooltip-cat-${props.row.id}`" triggers="hover" placement="left">{{ categoriePj[props.row.id] }}</b-tooltip>
              </div>
              <div slot="is_visible_for_client" slot-scope="props" :hidden="cantEditFicheDC(dossier)">
                <i title="Changer la visibilité" v-if="props.row.is_visible_for_client" class="fa fa-check clickable" @click="changeVisibility(props.row.id, props.row.is_visible_for_client)"></i>
                <i title="Changer la visibilité" v-if="!props.row.is_visible_for_client" class="fa fa-times clickable" @click="changeVisibility(props.row.id, props.row.is_visible_for_client)"></i>
              </div>
              <div slot="action" slot-scope="props">
                <i class="fa fa-download clickable ml-1" :class="canDelete(props.row) ? 'mr-2' : ''" title="télécharger" @click="download(props.row.id,props.row.name)"></i>
                <i v-if="canDelete(props.row)" class="fa fa-trash clickable text-danger" @click="deletePj(props.row.id,props.row.name)"></i>
              </div>
              <div slot="h__open">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="items"
                  aria-controls="items"
                  @change="toggleAll"
                  v-if="isNotPfe && !cantEditFicheDC(dossier)"
                >
                </b-form-checkbox>
              </div>
              <div slot="open" slot-scope="props">
                <b-form-checkbox
                  v-if="allowedExtensionForMultipleOpenning.indexOf(props.row.extension.toLowerCase()) > -1 && isNotPfe && !cantEditFicheDC(dossier)"
                  :id="'checkbox-'+props.row.id"
                  v-model="selectedPjs"
                  :value="props.row.id"
                >
                </b-form-checkbox>
              </div>
              <div slot="afterTable">
                <b-button v-if="showOpenPjButton" class="float-right fa fa-download" size="sm" variant="success" @click="openPjs()"> Ouvrir</b-button>
                <b-button v-if="showOpenPjButton" class="fa fa-file-image-o float-right mr-2" size="sm" variant="warning" @click="setPjsInutiles()"> Qualifier en inutile</b-button>
              </div>
            </v-client-table>
            <div class="table-wrapper">
              <div v-if="this.piecesJointesExterneFiltered.length > 0">
              <b-link v-b-toggle.collapseExterneFiltered>Voir les pj filtrées ({{ this.piecesJointesExterneFiltered.length }})</b-link>
              <b-collapse id="collapseExterneFiltered">
                <div>
                  <b-table class="table-pj" striped hover :items="piecesJointesExterneFiltered" :fields="fields" primary-key="id">
                    <template #cell(dossier_id)="data">
                      <img style="width: 20px;" class="mr-2" :src="getIconSrc(data.item)"> {{ getPjDossierId(data.item) }}
                    </template>
                    <template #cell(date_reception)="data">
                      {{ shortFormatDate(data.item.date_reception) }}
                    </template>
                    <template #cell(name)="data">
                      <a :id="`pj_${data.item.id}`" href="#" @click.prevent="download(data.item.id,data.item.name)"><span :title="data.item.name"> {{ reducedFileName(data.item.name) }}</span></a>
                      <i v-if="data.item.description" class="fa fa-question-circle ml-2" v-b-tooltip.hover :title="data.item.description"></i>
                      <i class="fa fa-pencil ml-2 clickable float-right" v-b-tooltip.hover.left title="Modifier le nom de la pièce jointe" @click="initModifyPj(data.item)" :hidden="cantEditFicheDC(dossier)"></i>
                    </template>
                    <template #cell(size)="data">
                      {{ getReadableFileSize(data.item.size) }}
                    </template>
                    <template #cell(categorie)="data">
                      <span :id="`tooltip-cat-${data.item.id}`">{{ categoriePj[data.item.id].length > 15 ? categoriePj[data.item.id].substring(0,12) + '...' : categoriePj[data.item.id] }}</span>
                      <b-tooltip v-if="categoriePj[data.item.id].length > 15" :target="`tooltip-cat-${data.item.id}`" triggers="hover" placement="left">{{ categoriePj[data.item.id] }}</b-tooltip>
                    </template>
                    <template #cell(is_visible_for_client)="data">
                      <i title="Changer la visibilité" v-if="data.item.is_visible_for_client" class="fa fa-check clickable" @click="changeVisibility(data.item.id, data.item.is_visible_for_client)"></i>
                      <i title="Changer la visibilité" v-if="!data.item.is_visible_for_client" class="fa fa-times clickable" @click="changeVisibility(data.item.id, data.item.is_visible_for_client)"></i>
                    </template>
                    <template #cell(action)="data">
                      <b-button type="button"
                                title="télécharger"
                                @click="download(data.item.id,data.item.name)"
                                size="sm"
                                variant="secondary">
                        <i class="fa fa-download"></i>
                      </b-button>
                      <b-button type="button"
                                title="Supprimer"
                                v-if="canDelete(data.item)"
                                @click="deletePj(data.item.id,data.item.name)"
                                size="sm"
                                class="ml-2"
                                variant="danger">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>
          </b-col>
          <b-col class="col-lg-6 col-md-12 pj-bloc pj-bloc-interne">
            <h5 class="mb-4">Interne</h5>
            <v-client-table id="table-pj-interne" ref="table-pj-interne" :columns="columns" :data="piecesJointesInterne" :options="options">
              <div slot="afterFilterWrapper">
                <b-button class="pull-right mb-3" type="button" @click="openModal(false)"
                  size="sm" variant="secondary" :hidden="cantEditFicheDC(dossier)">
                  <i class="fa fa-download"></i> Ajouter une pièce jointe
                </b-button>
              </div>
              <div slot="h__is_visible_for_client">
                <i class="fa fa-eye"></i> Clt
              </div>
              <div slot="dossier_id" slot-scope="props">
                <img style="width: 20px;" class="mr-2" :src="getIconSrc(props.row)"> {{ getPjDossierId(props.row) }}
              </div>
              <div slot="date_reception" slot-scope="props">
                {{ shortFormatDate(props.row.date_reception) }}
              </div>
              <div slot="name" slot-scope="props">
                <a :id="`pj_${props.row.id}`" href="#" @click.prevent="download(props.row.id,props.row.name)"><span :title="props.row.name"> {{ reducedFileName(props.row.name) }}</span></a>
                <i v-if="props.row.description" class="fa fa-question-circle ml-2" v-b-tooltip.hover :title="props.row.description"></i>
                <i class="fa fa-pencil ml-2 clickable float-right" v-b-tooltip.hover.left title="Qualifier pièce justificative" @click="initModifyPj(props.row)" :hidden="cantEditFicheDC(dossier)"></i>
              </div>
              <div slot="categorie" slot-scope="props">
                <span :id="`tooltip-cat-${props.row.id}`">{{ categoriePj[props.row.id].length > 15 ? categoriePj[props.row.id].substring(0,12) + '...' : categoriePj[props.row.id] }}</span>
                <b-tooltip v-if="categoriePj[props.row.id].length > 15" :target="`tooltip-cat-${props.row.id}`" triggers="hover" placement="left">{{ categoriePj[props.row.id] }}</b-tooltip>
              </div>
              <div slot="is_visible_for_client" slot-scope="props" :hidden="cantEditFicheDC(dossier)">
                <i title="Changer la visibilité" v-if="props.row.is_visible_for_client" class="fa fa-check clickable" @click="changeVisibility(props.row.id, props.row.is_visible_for_client)"></i>
                <i title="Changer la visibilité" v-if="!props.row.is_visible_for_client" class="fa fa-times clickable" @click="changeVisibility(props.row.id, props.row.is_visible_for_client)"></i>
              </div>
              <div slot="action" slot-scope="props">
                <i class="fa fa-download clickable" title="télécharger" @click="download(props.row.id,props.row.name)"></i>
                <i v-if="canDelete(props.row)" class="fa fa-trash clickable text-danger" @click="deletePj(props.row.id,props.row.name)"></i>
              </div>
            </v-client-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-modal title="Ajouter une pièce jointe" v-model="modalShow">
      <b-form>
        <div>
          <b-form-group v-for="group in groupTypes" :key="group.parent.id">
            <template slot="label"><b>{{ group.parent.libelle }}</b></template>
            <b-form-checkbox-group
              v-if="group != 'null'"
              :id="'checkbox-group-type-'+group.parent.id"
              v-model="typesId"
              :options="group.typesOptions"
              name="modifyPj_type"
            >
            </b-form-checkbox-group>
            <span class="field-error">{{ errors.typeDocument }}</span>
          </b-form-group>
        </div>
        <div>
          <b-form-group
            label-for='nom_fichier'>
            <template slot="label"><b>Pièce jointe</b></template>
            <b-form-file placeholder="Joindre un ou plusieurs fichiers"
                         class="file-input"
                         drop-placeholder="Déposer le/les fichiers ici..."
                         browse-text="Parcourir"
                         :state="errors.attachment !== '' ? false : null"
                         @change="addFile($event)"
                         multiple>
            </b-form-file>
            <span class="field-error">{{ errors.attachment }}</span>
          </b-form-group>
        </div>
        <div>
          <b-form-group
            label-for="Date de réception">
            <template slot="label"><b>Date de réception</b></template>
            <b-form-input type="date" id="date_reception" v-model="dateReception"></b-form-input>
            <span class="field-error">{{ errors.dateReception }}</span>
          </b-form-group>
        </div>
        <div v-if="isDcPrestation">
          <b-form-group>
            <template slot="label"><b>Bénéficiaire</b></template>
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="beneficiairesId"
              :options="beneficiaireDecesOptions"
              name="modifyPj_beneficiaire"
            >
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-checkbox v-model="pjOk" name="check-button" switch>Document valide</b-form-checkbox>
        </div>
        <div>
          <b-form-group
            label-for='description'>
            <template slot="label"><b>Description</b></template>
            <b-form-textarea
              id="description"
              type="text"
              v-model="description"
              rows="3"
              max-rows="6">
            </b-form-textarea>
          </b-form-group>
        </div>
        <div>
          <b-form-checkbox v-model="isVisibleForClient" name="check-button" switch>
            {{ isVisibleForClient ? 'visible par le client' : 'Non visible par le client'}}
          </b-form-checkbox>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="upload">
            Enregistrer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="modalShow=false">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" id="modal-mail" ref="modal-mail" title="Mail original" ok-only ok-title="Fermer">
      <b-card :title="`Mail n° ${mail.id}`">
        <b-card class="block-mail" :class="mail.is_neutralised ? 'neutralise' : ''">
          <b-list-group flush>
            <b-list-group-item>
              <b-row>
                <b-col sm="6" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        De :
                      </b-col>
                      <b-col sm="10">
                        {{ mail.mail_from }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
                <b-col sm="6">
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="6">
                  <b-row>
                    <b-col sm="2">
                      Objet :
                    </b-col>
                    <b-col sm="10">
                      {{ mail.subject }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col class="nopadding" sm="12">
                  <span class="float-right text-secondary">|<a href="" @click.prevent="toggleTextHtml">{{ showHtml ? 'HTML' : 'TEXT' }}</a>|</span>
                  <b-card-text v-show="!showHtml" class="pre-formatted">
                    {{ mail.body_text }}
                  </b-card-text>
                  <b-card-text v-show="showHtml" v-html="mail.body_html">
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card>
    </b-modal>
    <b-modal size="xl" id="modal-mails-fusion" ref="modal-mails-fusion" title="Mails fusionné (Retour DPC ou Manuel)" ok-only ok-title="Fermer">
      <b-card v-for="mail in mails" :key="mail.id">
        <b-card-title>{{ `Mail n° ${mail.id}` }} <b-button v-if="canReply(mail)" class="pull-right" type="button" variant="primary" @click.prevent="repondre(mail)">Répondre</b-button></b-card-title>
        <b-card class="block-mail" :class="mail.is_neutralised ? 'neutralise' : ''">
          <b-list-group flush>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        De :
                      </b-col>
                      <b-col sm="10">
                        {{ mail.mail_from }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
                <b-col sm="12">
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Objet :
                    </b-col>
                    <b-col sm="10">
                      {{ mail.subject }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Reçu le :
                    </b-col>
                    <b-col sm="10">
                      {{ getformattedDateTime(mail.date_reception_mail) }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <div v-if="!showContentMail[mail.id]" v-b-toggle="`collapse-body-${mail.id}`" class="clickable link text-warning">voir le message</div>
              <div v-if="showContentMail[mail.id]" v-b-toggle="`collapse-body-${mail.id}`" class="clickable link text-warning">cacher le message</div>
              <b-collapse :id="`collapse-body-${mail.id}`" v-model="showContentMail[mail.id]" class="m-3" :class="showContentMail[mail.id] ? null : 'collapsed'">
                <b-row>
                  <b-col class="nopadding" sm="12">
                    <span class="float-right text-secondary">|<a href="" @click.prevent="toggleTextHtmlMail(mail)">{{ showHtmlMails[mail.id] ? 'HTML' : 'TEXT' }}</a>|</span>
                    <b-card-text v-show="!showHtmlMails[mail.id]" class="pre-formatted">
                      {{ mail.body_text }}
                    </b-card-text>
                    <b-card-text v-show="showHtmlMails[mail.id]" v-html="mail.body_html">
                    </b-card-text>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card>
    </b-modal>

    <b-modal no-close-on-backdrop size="xl" id="modal-modify-pj" centered  ref="modal-modify-pj" :title="titreModalModification">
      <b-row>
        <b-col sm="6" class="border-right">
          <b-form>
            <div>
              <template slot="label"><b>Type</b></template>
              <b-form-group v-for="group in groupTypes" :key="group.parent.id">
                <template slot="label"><b>{{ group.parent.libelle }}</b></template>
                <b-form-checkbox-group
                  v-if="group != 'null'"
                  :id="'checkbox-group-type-'+group.parent.id"
                  v-model="typesId"
                  :options="group.typesOptions"
                  name="modifyPj_type"
                >
                </b-form-checkbox-group>
              </b-form-group>
            </div>
            <div v-if="isDcPrestation">
              <b-form-group>
                <template slot="label"><b>Bénéficiaire</b></template>
                <b-form-checkbox-group
                  v-if="!isEmpty(beneficiaireDecesOptions)"
                  id="checkbox-group-2"
                  v-model="beneficiairesId"
                  :options="beneficiaireDecesOptions"
                  name="modifyPj_beneficiaire"
                >
                </b-form-checkbox-group>
                <span v-else>Aucun bénéficiaire renseigné pour l'instant</span>
              </b-form-group>
              <b-form-checkbox v-model="pjOk" name="check-button" switch>Document valide</b-form-checkbox>
            </div>
            <div>
              <b-form-group
                label-for="newFilename"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Nom de la PJ :</b></template>
                <b-form-input id="newFilename" type="text" v-model="newFilename" :class="{hasError: errors.newFilename !== ''}">
                </b-form-input>
                <span class="field-error">{{ errors.newFilename }}</span>
              </b-form-group>
            </div>
            <div>
              <b-form-group
                label-for='description'>
                <template slot="label"><b>Description</b></template>
                <b-form-textarea
                  id="description"
                  type="text"
                  v-model="description"
                  rows="3"
                  max-rows="6">
                </b-form-textarea>
              </b-form-group>
            </div>
          </b-form>
        </b-col>
        <b-col sm="6">
          <b-row>
            <b-col sm="12">
              <b-form-checkbox
                size="sm"
                id="checkbox-replier"
                v-model="closeCollapseAll"
                name="checkbox-1"
                value="close"
                unchecked-value="open"
                class="float-right"
                @change="toggleCollapse"
              >
                replier tous
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form>
            <div v-show="showPeriodeAvisImpot">
              <form-periode-avis-impot :dataAvisImpot="periodeAvisImpot" titre="Avis d'Imposition" :typePeriode="typeAvisImpositionIds"><span class="ml-2 field-error">{{ errors.periodeAvisImpot }}</span></form-periode-avis-impot>
            </div>
            <div v-for="periode in periodes">
              <form-periode-type-pj :periodeOptions="periode.periodeOptions" :anneeOptions="periode.anneeOption" :titre="periode.titre" :typePeriode="periode.typeIds" :multiType="multiType" :periodes="periodes" :libelleTechnique="periode.libelle_technique ? periode.libelle_technique : '' " :attestationRessource="periode.libelle_technique ? typeAttestationRessource : '' "><span class="ml-2 field-error">{{ errors[periode.error] }}</span></form-periode-type-pj>
            </div>
          </b-form>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right ml-2" @click="modifyPj">Enregistrer</b-button>
          <b-button variant="secondary" class="float-right" @click="closeModifyPjModal">Annuler</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close title="Envoi de DPC" id="modal-mail-dpc" ref="modal-mail-dpc">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="reponseTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseTo" type="text" v-model="reponseTo"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="reponseCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseCc" type="text" v-model="reponseCc"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="reponseSubject">Objet :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseSubject" type="text" v-model="reponseSubject" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=8>
            <ul class="no-padding no-decoration">
              <li v-for="(pj, key) in dpcAttachmentsUploaded" :key="key">
                <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}} <i v-if="canDeleteDpcPj()" @click="deleteDpcPj(pj)" class="fa fa-trash text-danger clickable"></i>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="6">
            <b-row align-h="start" class="mt-2">
              <b-col sm="2">
                <label for="files">Fichier(s) :</label>
              </b-col>
              <b-col sm="8">
                <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                  multiple
                  class="file-input"
                  drop-placeholder="Déposer le(s) fichier(s) ici..."
                  browse-text="Parcourir"
                  :file-name-formatter="formatNames"
                  @change="addFileToDpc($event)"
                >
                </b-form-file>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <b-row class="pre-formatted">
          <ckeditor :editor="editor" v-model="reponseBody" :config="editorConfig"></ckeditor>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="sendReponse()">
            <i class="fa fa-paper-plane"></i>
            Envoyer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="closeReponseMailModal()">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '@/utils/auth';
  import {downloadFile, isEmpty, nl2br, getIconSrc as getIconSrcMain, getReadableFileSize as getReadableFileSizeMain, permittedExtension, guardedFile} from "@/utils/fileHelper";
  import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";
  import { isResponsable } from "@/utils/userHelper";
  import { formatDateTime, cantEditFicheDC } from "@/utils/communHelper";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import FormPeriodeTypePj from "@/components/Dossier/DetailsDossier/FormPeriodeTypePj";
  import FormPeriodeAvisImpot from "@/components/Dossier/DetailsDossier/FormPeriodeAvisImpot";

  export default {
    name: "PiecesJointes",
    props: [
      'dossier'
    ],
    components: {
      FormPeriodeTypePj,
      FormPeriodeAvisImpot
    },
    data() {
      let self = this;
      return {
        allSelected: false,
        indeterminate: false,
        selectedPjs: [],
        showOpenPjButton: false,
        isNotPfe: false,
        allowedExtensionForMultipleOpenning: ['jpg', 'jpeg', 'png', 'pdf'],
        isEmpty,
        closeCollapseAll: 'open',
        showPeriodeBs: false,
        showPeriodeDecompte: false,
        showPeriodeAvisImpot: false,
        showPeriodeAttestationRessource: false,
        showPeriodeDecomptePoleEmploi: false,
        showPeriodeNotificationRetraite: false,
        showPeriodeDeclarationCA: false,
        showPeriodeExtraitBancaireSS: false,
        showPeriodeExtraitBancaireAutreOrg: false,
        showPeriodeNotificationPoleEmploi: false,
        showPeriodeCertificatTravail: false,
        showPeriodeNotificationRente: false,
        showPeriodeNotificationRevRenteSS: false,
        showPeriodeNotificationDeces: false,
        showPeriodeNotificationsuspensionRenteSS: false,
        titreModalModification: 'Qualification de la pièce jointe',
        editor: ClassicEditor,
        editorConfig: {
            allowedContent: true,
            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo' ],
            language: 'fr'
        },
        columns: [
          'dossier_id',
          'date_reception',
          'name',
          'categorie',
          'is_visible_for_client',
          'action',
          'open'
        ],
        items: [],
        options: {
          headings: {
            dossier_id: 'N° Dossier',
            date_reception: 'Date',
            name: 'Libellé',
            categorie: 'Catégorie',
            is_visible_for_client: '',
            action: '',
            open: ''
          },
          filterAlgorithm: {
            beneficiaire_nom(row, query) {
              let value = '';
              if (!isEmpty(row.beneficiares_deces)) {
                for (let beneficiaire of row.beneficiares_deces) {
                  value = value + beneficiaire.nom;
                }
              }
              return (value.toLowerCase()).includes(query.toLowerCase());
            },
            beneficiaire_prenom(row, query) {
              let value = '';
              if (!isEmpty(row.beneficiares_deces)) {
                for (let beneficiaire of row.beneficiares_deces) {
                  value = value + beneficiaire.prenom;
                }
              }
              return (value.toLowerCase()).includes(query.toLowerCase());
            },
            categorie(row, query) {
              let value = self.getCategorie(row);
              // console.log('dans filtre value : ',value)

              return (value.toLowerCase()).includes(query.toLowerCase());
            },
          },
          columnsClasses: {
            is_visible_for_client: 'p-0 text-center',
            dossier_id: ' pl-1 pr-1',
            name: 'libelle-max-width',
            open: 'p-0',
            // date_rentes_transmis: 'date-header',
            // date_allocations_transmis: 'date-header',
            action: 'p-0'
          },
          rowClassCallback(row) {
            // if(row.is_active == false){
            //   return "desactive";
            // }else if(row.profil_active[0] == undefined && row.profil_futur != undefined){
            //   return "inactive";
            // }

          },
          filterByColumn: false,
          sortable: ['date_reception', 'name'],
          filterable: ['name','beneficiaire_nom','beneficiaire_prenom','categorie'],
          perPage: 1000,
          perPageValues: [],
          texts: {
            filterPlaceholder: "Libellé, Prénom/Nom bénéficiaire décès"
          },
          orderBy: { column: "date_reception", ascending: true }
        },
        isVisibleForClient: false,
        isFromClient: false,
        description: '',
        selectedType: null,
        selectedTypeSecondaire: null,
        modalShow: false,
        visible: false,
        // dossier: {},
        detailsPjNonAccessibles: '',
        detailsPjAccessibles: '',
        piecesJointes: [],
        fields: [{ key: 'dossier_id', label: 'N° Dossier', class: 'text-nowrap'},
          { key: 'date_reception', label: 'Date' },
          { key: 'name', label: 'Libellé', class: 'text-nowrap'},
          // { key: 'size', label: 'Taille', class: 'text-nowrap'},
          { key: 'categorie', label: 'Catégorie', sortByFormatted: true, sortable: true, formatter: (value, key, item) => {
              return this.getCategorie(item);
            }
          },
          { key: 'is_visible_for_client', label: 'Visu Clt', class: 'text-center' },
          { key: 'action', label: '' }],
        sortBy: 'categorie',
        extensionIcon: [],
        allTypes: [],
        parentTypes: [],
        typesPrincipaux: [],
        typesSecondaires: [],
        attachment: null,
        disableSousType: false,
        statusId: null,
        dateReception: null,
        showHtml: true,
        showHtmlMails: [],
        showContentMail: [],
        mail: {},
        mails: [],
        newFilename: '',
        pjToRename: {},
        errors: {
          dateReception: '',
          typeDocument: '',
          periodesBs: '',
          periodesDecompte: '',
          periodeAttestationRessource: '',
          periodeDecomptePoleEmploi: '',
          periodeNotificationRetraite: '',
          periodeDeclarationCA: '',
          periodeExtraitBancaireSS: '',
          periodeExtraitBancaireAutreOrg: '',
          periodeNotificationPoleEmploi: '',
          periodeCertificatTravail: '',
          periodeNotificationRente: '',
          periodeNotificationRevRenteSS: '',
          periodeNotificationDeces: '',
          periodeNotificationsuspensionRenteSS: '',
          periodeAvisImpot: '',
          typeSecondaire: '',
          attachment: '',
          newFilename: ''
        },
        reponseTo: '',
        reponseCc: '',
        reponseSubject: '',
        reponseBody: '',
        dpcAttachmentsUploaded: [],
        dpcAttachments: [],
        beneficiaireDecesOptions: [],
        beneficiairesId: [],
        typesId: [],
        groupTypes: [],
        pjOk: '',
        categoriePj: {},
        isDcPrestation: false,
        periodesBs: [],
        anneeBs: [],
        periodesDecompte: [],
        anneeDecompte: [],
        periodeAvisImpot: [],
        periodeAttestationRessource: [],
        anneeAttestationRessource: [],
        typeAttestationRessource: '',
        periodeDecomptePoleEmploi: [],
        anneeDecomptePoleEmploi: [],
        periodeNotificationRetraite: [],
        anneeNotificationRetraite: [],
        periodeDeclarationCA: [],
        anneeDeclarationCA: [],
        periodeExtraitBancaireSS: [],
        anneeExtraitBancaireSS: [],
        periodeExtraitBancaireAutreOrg: [],
        anneeExtraitBancaireAutreOrg: [],
        periodeNotificationPoleEmploi: [],
        anneeNotificationPoleEmploi: [],
        periodeCertificatTravail: [],
        anneeCertificatTravail: [],
        periodeNotificationRente: [],
        anneeNotificationRente: [],
        periodeNotificationRevRenteSS: [],
        anneeNotificationRevRenteSS: [],
        periodeNotificationDeces: [],
        anneeNotificationDeces: [],
        periodeNotificationsuspensionRenteSS: [],
        anneeNotificationsuspensionRenteSS: [],
        typeBsIds: {},
        typeDecompteIds: {},
        typeAvisImpositionIds: {},
        typeAttestationRessourceIds: {},
        typeDecomptePoleEmploiIds: {},
        typeNotificationRetraiteIds: {},
        typeDeclarationCAIds: {},
        typeExtraitBancaireSSIds: {},
        typeExtraitBancaireAutreOrgIds: {},
        typeNotificationPoleEmploiIds: [],
        typeCertificatTravailIds: [],
        typeNotificationRenteIds: [],
        typeNotificationRevRenteSSIds: [],
        typeNotificationDecesIds: [],
        typeNotificationsuspensionRenteSSIds: [],
        periodes: [],
        multiType: false,
      }
    },
    watch: {
      selectedPjs(newVal, oldVal) {
        // console.log('selectedPjs',this.selectedPjs)
        if (!isEmpty(this.selectedPjs)) {
          this.showOpenPjButton = true;
        } else {
          this.showOpenPjButton = false;
        }
        let totalPjOpenable = 0;
        for (let row of this.$refs['table-pj-externe'].data) {
          if(this.allowedExtensionForMultipleOpenning.indexOf(row.extension.toLowerCase()) > -1) {
            totalPjOpenable++;
          }
        }
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === totalPjOpenable) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
      dossier() {
        this.beneficiaireDecesOptions = [];
        if (!isEmpty(this.dossier.deces_beneficiaire)) {
          for (let beneficiaire of this.dossier.deces_beneficiaire) {
            this.beneficiaireDecesOptions.push({text: beneficiaire.prenom+' '+beneficiaire.nom, value: beneficiaire.id})
          }
        }
      },
      beneficiairesId() {
        if (!isEmpty(this.beneficiairesId)) {
          // S'il y a un bénéficiaire de coché, on met son nom, sinon on met "multi"
          if (this.beneficiairesId.length === 1) {
            let beneficiaire = this.dossier.deces_beneficiaire.find(beneficiaire => beneficiaire.id === this.beneficiairesId[0]);
            let reg = new RegExp(beneficiaire.prenom+'_'+beneficiaire.nom);
            if (!reg.test(this.newFilename)) {
              let typeSecondaire = this.allTypes.find(type => type.id === this.selectedTypeSecondaire);
              this.newFilename = typeSecondaire.libelle_court+'_'+beneficiaire.prenom+'_'+beneficiaire.nom;
            }
          } else {
            let reg = new RegExp('multi');
            if (!reg.test(this.newFilename)) {
              let typeSecondaire = this.allTypes.find(type => type.id === this.selectedTypeSecondaire);
              this.newFilename = typeSecondaire.libelle_court+'_multi';
            }
          }
        }
      },
      typesId() {
        if (!isEmpty(this.typesId)) {
          // On commence par caché tous les blocs de périodes
          this.hideFormsPeriode();
          // On montre les blocs périodes associés
          let intersectionBs = this.typeBsIds.filter(x => this.typesId.includes(x));
          let periodeBsObject = {periodeOptions: this.periodesBs, anneeOption: this.anneeBs, titre: 'Périodes du/des BS', typeIds: this.typeBsIds, error: 'periodesBs'};
          if (intersectionBs.length > 0) {
            let contains = this.containsPeriode(periodeBsObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeBsObject);
            }
          } else {
            let contains = this.containsPeriode(periodeBsObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionDecompte = this.typeDecompteIds.filter(x => this.typesId.includes(x));
          let periodeDecompteObject = {periodeOptions: this.periodesDecompte, anneeOption: this.anneeDecompte, titre: 'Périodes du/des Décompte SS', typeIds: this.typeDecompteIds, error: 'periodesDecompte'};
          if (intersectionDecompte.length > 0) {
            let contains = this.containsPeriode(periodeDecompteObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeDecompteObject);
            }
          } else {
            let contains = this.containsPeriode(periodeDecompteObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionAttestationRessource = this.typeAttestationRessourceIds.filter(x => this.typesId.includes(x));
          let periodeAttestationRessourceObject = {periodeOptions: this.periodeAttestationRessource, anneeOption: this.anneeAttestationRessource, titre: 'Périodes du/des Attestation de ressource', typeIds: this.typeAttestationRessourceIds, error: 'periodeAttestationRessource', libelle_technique: 'attestation_ressources', typeAttestationRessource: this.typeAttestationRessource};
          if (intersectionAttestationRessource.length > 0) {
            let contains = this.containsPeriode(periodeAttestationRessourceObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeAttestationRessourceObject);
            }
          } else {
            let contains = this.containsPeriode(periodeAttestationRessourceObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionDecomptePoleEmploi = this.typeDecomptePoleEmploiIds.filter(x => this.typesId.includes(x));
          let periodeDecomptePoleEmploiObject = {periodeOptions: this.periodeDecomptePoleEmploi, anneeOption: this.anneeDecomptePoleEmploi, titre: 'Périodes du/des Décompte Pôle Emploi', typeIds: this.typeDecomptePoleEmploiIds, error: 'periodeDecomptePoleEmploi'};
          if (intersectionDecomptePoleEmploi.length > 0) {
            let contains = this.containsPeriode(periodeDecomptePoleEmploiObject, this.periodes);
            // console.log('contains',contains)
            if (!contains.contains) {
              this.periodes.unshift(periodeDecomptePoleEmploiObject);
            }
          } else {
            let contains = this.containsPeriode(periodeDecomptePoleEmploiObject, this.periodes);
            // console.log('contains.index',contains.index)
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationRetraite = this.typeNotificationRetraiteIds.filter(x => this.typesId.includes(x));
          let periodeNotificationRetraiteObject = {periodeOptions: this.periodeNotificationRetraite, anneeOption: this.anneeNotificationRetraite, titre: 'Périodes de la notification de retraite', typeIds: this.typeNotificationRetraiteIds, error: 'periodeNotificationRetraite'};
          if (intersectionNotificationRetraite.length > 0) {
            let contains = this.containsPeriode(periodeNotificationRetraiteObject, this.periodes);
            // console.log('contains',contains)
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationRetraiteObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationRetraiteObject, this.periodes);
            // console.log('contains.index',contains.index)
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionDeclarationCA = this.typeDeclarationCAIds.filter(x => this.typesId.includes(x));
          let periodeDeclarationCAObject = {periodeOptions: this.periodeDeclarationCA, anneeOption: this.anneeDeclarationCA, titre: 'Périodes de la/des déclaration de chiffre d\'affaire', typeIds: this.typeDeclarationCAIds, error: 'periodeDeclarationCA'};
          if (intersectionDeclarationCA.length > 0) {
            let contains = this.containsPeriode(periodeDeclarationCAObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeDeclarationCAObject);
            }
          } else {
            let contains = this.containsPeriode(periodeDeclarationCAObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionExtraitBancaireSS = this.typeExtraitBancaireSSIds.filter(x => this.typesId.includes(x));
          let periodeExtraitBancaireSSObject = {periodeOptions: this.periodeExtraitBancaireSS, anneeOption: this.anneeExtraitBancaireSS, titre: 'Périodes du/des extrait bancaire - virement SS', typeIds: this.typeExtraitBancaireSSIds, error: 'periodeExtraitBancaireSS'};
          if (intersectionExtraitBancaireSS.length > 0) {
            let contains = this.containsPeriode(periodeExtraitBancaireSSObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeExtraitBancaireSSObject);
            }
          } else {
            let contains = this.containsPeriode(periodeExtraitBancaireSSObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionExtraitBancaireAutreOrg = this.typeExtraitBancaireAutreOrgIds.filter(x => this.typesId.includes(x));
          let periodeExtraitBancaireAutreOrgObject = {periodeOptions: this.periodeExtraitBancaireAutreOrg, anneeOption: this.anneeExtraitBancaireAutreOrg, titre: 'Périodes du/des extrait bancaire - autre organisme', typeIds: this.typeExtraitBancaireAutreOrgIds, error: 'periodeExtraitBancaireAutreOrg'};
          if (intersectionExtraitBancaireAutreOrg.length > 0) {
            let contains = this.containsPeriode(periodeExtraitBancaireAutreOrgObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeExtraitBancaireAutreOrgObject);
            }
          } else {
            let contains = this.containsPeriode(periodeExtraitBancaireAutreOrgObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationPoleEmploi = this.typeNotificationPoleEmploiIds.filter(x => this.typesId.includes(x));
          let periodeNotificationPoleEmploiObject = {periodeOptions: this.periodeNotificationPoleEmploi, anneeOption: this.anneeNotificationPoleEmploi, titre: 'Périodes de la notification Pôle Emploi', typeIds: this.typeNotificationPoleEmploiIds, error: 'periodeNotificationPoleEmploi'};
          if (intersectionNotificationPoleEmploi.length > 0) {
            let contains = this.containsPeriode(periodeNotificationPoleEmploiObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationPoleEmploiObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationPoleEmploiObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionCertificatTravail = this.typeCertificatTravailIds.filter(x => this.typesId.includes(x));
          let periodeCertificatTravailObject = {periodeOptions: this.periodeCertificatTravail, anneeOption: this.anneeCertificatTravail, titre: 'Périodes du certificat de travail', typeIds: this.typeCertificatTravailIds, error: 'periodeCertificatTravail'};
          if (intersectionCertificatTravail.length > 0) {
            let contains = this.containsPeriode(periodeCertificatTravailObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeCertificatTravailObject);
            }
          } else {
            let contains = this.containsPeriode(periodeCertificatTravailObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationRente = this.typeNotificationRenteIds.filter(x => this.typesId.includes(x));
          let periodeNotificationRenteObject = {periodeOptions: this.periodeNotificationRente, anneeOption: this.anneeNotificationRente, titre: 'Périodes du/des Notification de rente', typeIds: this.typeNotificationRenteIds, error: 'periodeNotificationRente'};
          if (intersectionNotificationRente.length > 0) {
            let contains = this.containsPeriode(periodeNotificationRenteObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationRenteObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationRenteObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationRevRenteSS = this.typeNotificationRevRenteSSIds.filter(x => this.typesId.includes(x));
          let periodeNotificationRevRenteSSObject = {periodeOptions: this.periodeNotificationRevRenteSS, anneeOption: this.anneeNotificationRevRenteSS, titre: 'Périodes du/des Notification de révision de rente SS', typeIds: this.typeNotificationRevRenteSSIds, error: 'periodeNotificationRevRenteSS'};
          if (intersectionNotificationRevRenteSS.length > 0) {
            let contains = this.containsPeriode(periodeNotificationRevRenteSSObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationRevRenteSSObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationRevRenteSSObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationDeces = this.typeNotificationDecesIds.filter(x => this.typesId.includes(x));
          let periodeNotificationDecesObject = {periodeOptions: this.periodeNotificationDeces, anneeOption: this.anneeNotificationDeces, titre: 'Périodes de la Notification de décès', typeIds: this.typeNotificationDecesIds, error: 'periodeNotificationDeces'};
          if (intersectionNotificationDeces.length > 0) {
            let contains = this.containsPeriode(periodeNotificationDecesObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationDecesObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationDecesObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }

          let intersectionNotificationsuspensionRenteSS = this.typeNotificationsuspensionRenteSSIds.filter(x => this.typesId.includes(x));
          let periodeNotificationsuspensionRenteSSObject = {periodeOptions: this.periodeNotificationsuspensionRenteSS, anneeOption: this.anneeNotificationsuspensionRenteSS, titre: 'Périodes du/des Notification de susp. de la rente SS', typeIds: this.typeNotificationsuspensionRenteSSIds, error: 'periodeNotificationsuspensionRenteSS'};
          if (intersectionNotificationsuspensionRenteSS.length > 0) {
            let contains = this.containsPeriode(periodeNotificationsuspensionRenteSSObject, this.periodes);
            if (!contains.contains) {
              this.periodes.unshift(periodeNotificationsuspensionRenteSSObject);
            }
          } else {
            let contains = this.containsPeriode(periodeNotificationsuspensionRenteSSObject, this.periodes);
            if (contains.index > -1) {
              this.periodes.splice(contains.index,1);
            }
          }
          for (let typeId of this.typesId) {
            if (this.typeAvisImpositionIds.indexOf(parseInt(typeId,10)) > -1) {
              this.showPeriodeAvisImpot = true;
            }
          }
          // S'il y a un seul type de coché, on met son libelle, sinon on met "multi"
          if (this.typesId.length === 1) {
            let type = this.allTypes.find(type => type.id === this.typesId[0])
            let reg = new RegExp(type.libelle_court);
            if (!reg.test(this.newFilename) && type.libelle_technique !== 'doublon' && type.libelle_technique !== 'inutiles') {
              this.newFilename = type.libelle_court;
              // On regarde s'il y a un bénéficiaire d'indiqué pour ajouter au nom du fichier
              if (!isEmpty(this.beneficiairesId)) {
                if (this.beneficiairesId.length === 1) {
                  let beneficiaire = this.dossier.deces_beneficiaire.find(beneficiaire => beneficiaire.id === this.beneficiairesId[0]);
                  this.newFilename = this.newFilename+'_'+beneficiaire.prenom+'_'+beneficiaire.nom;
                } else {
                  this.newFilename = this.newFilename+'_multi';
                }
              }
            }
            this.multiType = false
          } else {
            let reg = new RegExp(/^multi/);
            if (!reg.test(this.newFilename)) {
              this.newFilename = 'multi';
              if (!isEmpty(this.beneficiairesId)) {
                if (this.beneficiairesId.length === 1) {
                  let beneficiaire = this.dossier.deces_beneficiaire.find(beneficiaire => beneficiaire.id === this.beneficiairesId[0]);
                  this.newFilename = 'multi_'+beneficiaire.prenom+'_'+beneficiaire.nom;
                } else {
                  this.newFilename = 'multi_multi';
                }
              }
            }
            this.multiType = true
          }
        } else {
          this.hideFormsPeriode();
        }
      },
      pjOk() {
        if (!isEmpty(this.pjOk)) {
          if (this.pjOk === true) {
            let reg = new RegExp('OK');
            if (!reg.test(this.newFilename)) {
              // On commence par enlever un potentiel _KO
              this.newFilename = this.newFilename.replace('_KO', '');
              // On rajoute le _OK
              this.newFilename = this.newFilename+'_OK';
            }
          } else if (this.pjOk === false) {
            let reg = new RegExp('KO');
            if (!reg.test(this.newFilename)) {
              // On commence par enlever un potentiel _OK
              this.newFilename = this.newFilename.replace('_OK', '');
              // On rajoute le _KO
              this.newFilename = this.newFilename+'_KO';
            }
          }
        }
      },
      piecesJointes() {
        this.visible = this.piecesJointes && this.piecesJointes.length > 0;
      },
      allTypes() {
        if (!isEmpty(this.allTypes)) {
          this.typeBsIds = this.allTypes.filter(type => ['bs', 'bs_dc'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeDecompteIds = this.allTypes.filter(type => ['decomptes_ss'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeAvisImpositionIds = this.allTypes.filter(type => ['avis_imposition_inval', 'avis_imposition_dc'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeAttestationRessourceIds = this.allTypes.filter(type => ['attestation_ressources_inval'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeDecomptePoleEmploiIds = this.allTypes.filter(type => ['decompte_pole_emploi'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationRetraiteIds = this.allTypes.filter(type => ['notification_retraite'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeDeclarationCAIds = this.allTypes.filter(type => ['declaration_chiffre_affaire'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeExtraitBancaireSSIds = this.allTypes.filter(type => ['extrait_bancaire_ss'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeExtraitBancaireAutreOrgIds = this.allTypes.filter(type => ['extrait_bancaire_autre_org'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationPoleEmploiIds = this.allTypes.filter(type => ['notification_pole_emploi'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeCertificatTravailIds = this.allTypes.filter(type => ['certificat_travail'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationRenteIds = this.allTypes.filter(type => ['notification_rente'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationRevRenteSSIds = this.allTypes.filter(type => ['notification_revision_rente_ss'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationDecesIds = this.allTypes.filter(type => ['notification_deces'].indexOf(type.libelle_technique) > -1).map(type => type.id);
          this.typeNotificationsuspensionRenteSSIds = this.allTypes.filter(type => ['notification_suspension_rente_ss'].indexOf(type.libelle_technique) > -1).map(type => type.id);
        }
      },
    },
    computed: {
      piecesJointesInterne() {
        return _.filter(this.piecesJointes, (pj) => pj.is_from_client === false);
      },
      piecesJointesExterne() {
        return _.filter(this.piecesJointes, (pj) => {
          // let pjTypeIds = pj.types_pj ? pj.types_pj.map(type => type.id) : [];
          let pjTypeLibTech = pj.types_pj ? pj.types_pj.map(type => type.libelle_technique) : [];
          return pj.is_from_client === true && pjTypeLibTech.indexOf('doublon') === -1 && pjTypeLibTech.indexOf('inutiles') === -1
          // return pj.is_from_client === true && pjTypeIds.indexOf(75) === -1
        });
      },
      piecesJointesExterneFiltered() {
        return _.filter(this.piecesJointes, (pj) => {
          // let pjTypeIds = pj.types_pj ? pj.types_pj.map(type => type.id) : [];
          let pjTypeLibTech = pj.types_pj ? pj.types_pj.map(type => type.libelle_technique) : [];
          return pj.is_from_client === true && (pjTypeLibTech.indexOf('doublon') > -1 || pjTypeLibTech.indexOf('inutiles') > -1)
          // return pj.is_from_client === true && (pjTypeIds.indexOf(75) > -1 || pjTypeIds.indexOf(75) > -1)
        });
      }
    },
    async created() {
      // this.$axios.defaults.baseURL = getBaseUrl();
      // this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "application/json";
      // this.$axios.defaults.headers.common["Provider"] = getProvider();

      // this.piecesJointes = this.dossier.pieces_jointes;
      // this.visible = this.piecesJointes.length > 0;
      await this.getPiecesJointes();
      this.getTypesPiecesJointes();

      let currentTraitement = this.$parent.$parent.$parent.allTraitements.find(traitement => traitement.id === parseInt(this.$route.query.traitementId,10));
      this.isNotPfe = !isEmpty(currentTraitement) ? currentTraitement.libelle_technique !== 'qualification_courrier' : false;
      // console.log(this.dossier)
    },
    mounted() {

      this.beneficiaireDecesOptions = [];
      if (!isEmpty(this.dossier.deces_beneficiaire)) {
        for (let beneficiaire of this.dossier.deces_beneficiaire) {
          this.beneficiaireDecesOptions.push({text: beneficiaire.prenom+' '+beneficiaire.nom, value: beneficiaire.id})
        }
      }
      this.$event.on('changeAttestationREssource', (value) => {
        this.typeAttestationRessource = value
      })
    },
    methods: {
      toggleAll(checked) {
        let openablePjs = this.$refs['table-pj-externe'].data.filter(item => this.allowedExtensionForMultipleOpenning.indexOf(item.extension.toLowerCase()) > -1);
        this.selectedPjs = checked ? openablePjs.map(item => item.id) : []
      },
      containsPeriode(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (!isEmpty(list[i].error) && list[i].error === obj.error) {
                return {contains: true, index: i};
            }
        }

        return {contains: false, index: -1};
      },
      toggleCollapse() {
        // console.log('this.closeCollapseAll, this.typesId',this.closeCollapseAll, this.typesId)
        this.$event.emit('toggleCollapse', this.closeCollapseAll, this.typesId);
      },
      togglePjFiltered(){
        return _.filter(this.piecesJointes, (pj) => pj.is_from_client === true && pj.type_principal_id !== 75);
      },
      addFile(event) {
        this.attachment = event.target.files;
      },
      clearForm() {
        this.selectedType = null;
        this.selectedTypeSecondaire = null;
        this.disableSousType = false;
        this.periodes = [];
        this.typesId = [];
        this.beneficiairesId = [];
        this.pjOk = '';
        this.description = '';
      },
      openModal(isFromClient) {
        this.getStatusId();
        this.isFromClient = isFromClient;
        this.clearForm();
        let type = this.getTypeDossier();
        this.isDcPrestation = !isEmpty(type) && type.groupe.toLowerCase() === 'dc';
        this.setTypeSelectOption(type);
        // this.typesPrincipaux = [];
        // this.typesSecondaires = [];
        this.modalShow = true;

      },
      upload() {
        if (this.validateForm()) {
          // let periodes = {};
          // periodes = this.preparePeriode()
          let formData = new FormData();
          for( var i = 0; i < this.attachment.length; i++ ){
              let file = this.attachment[i];
              formData.append('files[' + i + ']', file);
          }
          let typeIds = [];
          for (let el of this.typesId) {
            formData.append('typesId[]', el);
          }
          // formData.append('file', this.attachment);
          // formData.append('typesId', typeIds);
          formData.append('periodes[]', []);
          // formData.append('type_principal', this.selectedType);
          formData.append('dossier_id', this.dossier.id);
          // formData.append('type_secondaire', this.selectedTypeSecondaire);
          formData.append('is_visible_for_client', this.isVisibleForClient);
          formData.append('is_from_client', this.isFromClient);
          formData.append('status_id', this.statusId);
          formData.append('description', this.description);
          formData.append('traitement_id', this.$route.query.traitementId);
          formData.append('date_reception', this.dateReception);
          formData.append('beneficiaires_id', this.beneficiairesId);
          formData.append('is_pj_ok', this.pjOk);
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post('/espaceGestion/dossier-pieces-jointes/upload',
              formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Une nouvelle pièce jointe a bien été créée',
                showConfirmButton: false,
                timer: 4000
              });
              // this.$event.emit('refreshDossier');
              this.getPiecesJointes();
              this.clearForm();
              this.modalShow = false;
            })
            .catch(() => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de l\'envoi du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            })
            .finally(() => this.$store.commit('IS_LOADING', false));
        }
      },
      download(id, filename) {
        let fileNameArr = filename.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        let link = document.getElementById('pj_'+id);
        link.style.color = 'violet';
        // console.log('link',link)
        if(this.canDownloadGuardedFile(ext)) {
          this.$axios
            .get("/espaceGestion/dossier-pieces-jointes/download/"+id, {responseType: 'blob'})
            .then(response => {
              downloadFile(response, name, ext);
            })
            .catch(() => {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 4000
              });
            })
        } else {
          this.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
            showConfirmButton: false,
            timer: 3500
          });
        }
      },
      canDelete(pj) {
        // HMESS-318
        if(cantEditFicheDC(this.dossier)) {
          return false;
        }
        // Fin
        let user = getUser();
        let isDocSensible = false;
        for (let typePj of pj.types_pj) {
          if (typePj.libelle_technique === 'document_medical') {
            isDocSensible = true;
            break;
          }
        }
        return (((isResponsable() && pj.source === 'gestionnaire') || (pj.source === 'gestionnaire' && pj.source_id === user.id)) && pj.can_be_deleted !== '0') || (isDocSensible && hasRule(rules.CAN_DELETE_PJ_MEDICAL));
      },
      deletePj(pjId) {
        let self = this
        let data = {};
        data.traitementId = this.$route.query.traitementId;
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce fichier ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post("/espaceGestion/dossier-pieces-jointes/delete/"+pjId,data)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                // this.$event.emit('refreshDossier');
                this.getPiecesJointes();
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le fichier a bien été supprimé',showConfirmButton: false, timer: 3000})
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      getIconSrc(pj) {
        // console.log('dans getIconSrc -> pj', pj)
        return pj.extension !== undefined ? getIconSrcMain(pj) : '';
      },
      getReadableFileSize(fileSizeInBytes) {
        return getReadableFileSizeMain(fileSizeInBytes)
      },
      reducedFileName(name) {
        if (name.length > 38) {
          return name.substring(0, 35) + ' ...';
        } else {
          return name;
        }
      },
      getTypesPiecesJointes() {
        let self = this;
        this.$axios
          .get("/espaceGestion/types-pieces-jointes")
          .then(response => {
            this.allTypes = response.data.types;
          })
          .catch(function(error){
            console.log(error)
            // self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
          });
      },
      setTypeSelectOption(actualType) {
        let groupTypes = [];
        let availableType = [];
        this.groupTypes = [];
        if (!isEmpty(actualType)) {
          let filtredType = _.filter(this.allTypes, (type) => type.type_dossier.toLowerCase().indexOf(actualType.groupe.toLowerCase()) > -1);
          availableType = _.groupBy(filtredType, type => type.parent_id);
        } else {
          availableType = _.groupBy(this.allTypes, (type) => type.parent_id);
        }
        // console.log('availableType',availableType)
        for (let parentId in availableType) {
          if (parentId !== null && parentId !== 'null') {
            let parent = this.allTypes.find(type => type.id === parseInt(parentId,10));
            let group = {parent: parent, typesOptions: []};
            for (let type of availableType[parentId]) {
              group.typesOptions.push({value: type.id, text: type.libelle});
            }
            groupTypes.push(group);
          }
        }
        // gestion des types Autres et Logo
        let groupDivers = {parent: {libelle: 'Divers'}, typesOptions: []};
        for (let parentId in availableType) {
          if (parentId === null || parentId === 'null') {
            for (let type of availableType[parentId]) {
              if (type.libelle_technique === 'autres' || type.libelle_technique === 'inutiles' || type.libelle_technique === 'doublon') {
                groupDivers.typesOptions.push({value: type.id, text: type.libelle})
              }
            }
          }
        }
        groupTypes.push(groupDivers);
        this.groupTypes = groupTypes;
        // console.log('groupTypes',groupTypes)
      },
      validateForm() {
        this.clearErrors();
        let isValid = true;
        if (this.attachment === null) {
          isValid = false;
          this.errors.attachment = 'Veuillez choisir une pièce jointe';
        }
        if (isEmpty(this.typesId)) {
          isValid = false;
          this.errors.typeDocument = 'Veuillez choisir un type de document';
        }

        if (this.attachment !== null) {
          for (let attachment of this.attachment) {
            if (!_.includes(permittedExtension, attachment.name.split('.').pop().toLowerCase())) {
              isValid = false;
              this.errors.attachment = "Le Format d'au moins un fichier n'est pas autorisé";
            }
          }

        }
        return isValid;
      },
      hideFormsPeriode() {
        this.showPeriodeBs = false;
        this.showPeriodeDecompte = false;
        this.showPeriodeAvisImpot = false;
        this.showPeriodeAttestationRessource = false;
        this.showPeriodeDecomptePoleEmploi = false;
        this.showPeriodeNotificationRetraite = false;
        this.showPeriodeDeclarationCA = false;
        this.showPeriodeExtraitBancaireSS = false;
        this.showPeriodeExtraitBancaireAutreOrg = false;
        this.showPeriodeNotificationPoleEmploi = false;
        this.showPeriodeCertificatTravail = false;
        this.showPeriodeNotificationRente = false;
        this.showPeriodeNotificationRevRenteSS = false;
        this.showPeriodeNotificationDeces = false;
        this.showPeriodeNotificationsuspensionRenteSS = false;
      },
      clearErrors() {
        this.errors.typeDocument = '';
        this.errors.periodesBs = '';
        this.errors.periodesDecompte = '';
        this.errors.periodeAttestationRessource = '';
        this.errors.periodeDecomptePoleEmploi = '';
        this.errors.periodeNotificationRetraite = '';
        this.errors.periodeDeclarationCA = '';
        this.errors.periodeExtraitBancaireSS = '';
        this.errors.periodeExtraitBancaireAutreOrg = '';
        this.errors.periodeNotificationPoleEmploi = '';
        this.errors.periodeCertificatTravail = '';
        this.errors.periodeNotificationRente = '';
        this.errors.periodeNotificationRevRenteSS = '';
        this.errors.periodeNotificationDeces = '';
        this.errors.periodeNotificationsuspensionRenteSS = '';
        this.errors.periodeAvisImpot = '';
        this.errors.attachment = '';
      },
      getStatusId() {
        for (let status of this.dossier.status) {
          if (status.pivot.traitement_id === this.$route.query.traitementId) {
            this.statusId = status.id;
          }
        }
      },
      shortFormatDate(textDate) {
        let formattedDate = null;
        // console.log('textDate',textDate)
        if(!isEmpty(textDate)) {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          if (date[0] === 'Invalid Date') {
            return textDate;
          }
          // console.log('date',date)
          formattedDate = `${date[0]}/${date[1]}/${date[2].slice(-2)}`;
        }
        return formattedDate;
      },
      changeVisibility(id, visibility) {
        this.$swal
          .fire({
            title: "Attention !",
            text: "Êtes-vous sûr de vouloir changer la visibilité client de cette pièce jointe ?",
            type: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler"
          })
          .then(result => {
            if (result.value) {
              this.$axios
                .post('/espaceGestion/dossier/changePjVisibilityForClient/'+ id, {visibility: visibility})
                .then(() => {
                  // this.$event.emit('refreshDossier');
                  this.getPiecesJointes();
                  this.$swal({
                    position: "top",
                    type: "success",
                    title: "Succès !",
                    text: 'Visibilité a été bien modifiée',
                    showConfirmButton: false,
                    timer: 3000
                  });
                })
                .catch(function(error){
                  console.log(error)
                  // self.$store.commit('IS_LOADING', false)
                  self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors du changement de visibilité pour le client. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
                });
            }
          })
      },
      canDownloadGuardedFile(extension) {
        let valid = true;
        if(_.includes(guardedFile, extension)) {
          valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
        }
        return valid;
      },
      showMail() {
        this.mail = this.dossier.mail;
        this.$refs['modal-mail'].show();
      },
      hasMails() {
        return !isEmpty(this.dossier.mails);
      },
      showMails() {
        let orderedMails = _.orderBy(this.dossier.mails, ['id'],['desc']);
        this.mails = orderedMails;

        for (let mail of orderedMails) {
          this.showContentMail[mail.id] = this.dossier.mails.length < 2;
          this.showHtmlMails[mail.id] = true;
        }
        this.$refs['modal-mails-fusion'].show();
      },
      toggleTextHtml() {
        this.showHtml = !this.showHtml;
      },
      toggleTextHtmlMail(mail) {
        this.$set(this.showHtmlMails, mail.id, !this.showHtmlMails[mail.id]);
      },
      initModifyPj(pj) {
        let actualType = this.getTypeDossier();
        if (isEmpty(actualType)) {
          this.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Vous devez selectionner la typologie du dossier avant de pouvoir qualifer une PJ..',showConfirmButton: false, timer: 6000})
        } else {
          this.clearForm();
          this.clearErrors();
          this.hideFormsPeriode();
          this.titreModalModification = 'Qualification de la pièce jointe ' + pj.name;

          let type = this.getTypeDossier();
          this.isDcPrestation = !isEmpty(type) && type.groupe.toLowerCase() === 'dc';
          this.setTypeSelectOption(type);
          // console.log('pj',pj)
          let filenameArr = pj.name.split('.');
          filenameArr.splice(filenameArr.length - 1,1);
          this.newFilename = filenameArr.join('.');
          this.pjToRename = pj;
          this.typesId = pj.types_pj.map(type => type.id);

          this.periodesBs = [];
          this.anneeBs = [];
          this.initPeriodes(pj, 'periodesBs', 'anneeBs', ['bs', 'bs_dc'], 'showPeriodeBs');

          this.periodesDecompte = [];
          this.anneeDecompte = [];
          this.initPeriodes(pj, 'periodesDecompte', 'anneeDecompte', ['decomptes_ss'], 'showPeriodeDecompte');

          this.periodeDecomptePoleEmploi = [];
          this.anneeDecomptePoleEmploi = [];
          this.initPeriodes(pj, 'periodeDecomptePoleEmploi', 'anneeDecomptePoleEmploi', ['decompte_pole_emploi'], 'showPeriodeDecomptePoleEmploi');

          this.periodeAttestationRessource = [];
          this.anneeAttestationRessource = [];
          this.typeAttestationRessource = [];
          this.initPeriodes(pj, 'periodeAttestationRessource', 'anneeAttestationRessource', ['attestation_ressources_inval'], 'showPeriodeAttestationRessource', 'typeAttestationRessource');

          this.periodeNotificationRetraite = [];
          this.anneeNotificationRetraite = [];
          this.initPeriodes(pj, 'periodeNotificationRetraite', 'anneeNotificationRetraite', ['notification_retraite'], 'showPeriodeNotificationRetraite');

          this.periodeDeclarationCA = [];
          this.anneeDeclarationCA = [];
          this.initPeriodes(pj, 'periodeDeclarationCA', 'anneeDeclarationCA', ['declaration_chiffre_affaire'], 'showPeriodeDeclarationCA');

          this.periodeExtraitBancaireSS = [];
          this.anneeExtraitBancaireSS = [];
          this.initPeriodes(pj, 'periodeExtraitBancaireSS', 'anneeExtraitBancaireSS', ['extrait_bancaire_ss'], 'showPeriodeExtraitBancaireSS');

          this.periodeExtraitBancaireAutreOrg = [];
          this.anneeExtraitBancaireAutreOrg = [];
          this.initPeriodes(pj, 'periodeExtraitBancaireAutreOrg', 'anneeExtraitBancaireAutreOrg', ['extrait_bancaire_autre_org'], 'showPeriodeExtraitBancaireAutreOrg');

          this.periodeNotificationPoleEmploi = [];
          this.anneeNotificationPoleEmploi = [];
          this.initPeriodes(pj, 'periodeNotificationPoleEmploi', 'anneeNotificationPoleEmploi', ['notification_pole_emploi'], 'showPeriodeNotificationPoleEmploi');

          this.periodeCertificatTravail = [];
          this.anneeCertificatTravail = [];
          this.initPeriodes(pj, 'periodeCertificatTravail', 'anneeCertificatTravail', ['certificat_travail'], 'showPeriodeCertificatTravail');

          this.periodeNotificationRente = [];
          this.anneeNotificationRente = [];
          this.initPeriodes(pj, 'periodeNotificationRente', 'anneeNotificationRente', ['notification_rente'], 'showPeriodeNotificationRente');

          this.periodeNotificationRevRenteSS = [];
          this.anneeNotificationRevRenteSS = [];
          this.initPeriodes(pj, 'periodeNotificationRevRenteSS', 'anneeNotificationRevRenteSS', ['notification_revision_rente_ss'], 'showPeriodeNotificationRevRenteSS');

          this.periodeNotificationDeces = [];
          this.anneeNotificationDeces = [];
          this.initPeriodes(pj, 'periodeNotificationDeces', 'anneeNotificationDeces', ['notification_deces'], 'showPeriodeNotificationDeces');

          this.periodeNotificationsuspensionRenteSS = [];
          this.anneeNotificationsuspensionRenteSS = [];
          this.initPeriodes(pj, 'periodeNotificationsuspensionRenteSS', 'anneeNotificationsuspensionRenteSS', ['notification_suspension_rente_ss'], 'showPeriodeNotificationsuspensionRenteSS');

          this.periodeAvisImpot = [];
          this.initPeriodeAvisImpot(pj);

          // this.selectedType = pj.type_principal_id;
          // if (!isEmpty(pj.type_principal_id)) { this.typeChanged(); }
          // this.selectedTypeSecondaire = pj.type_secondaire_id;
          if (!isEmpty(pj.beneficiares_deces)) {
            this.beneficiairesId = pj.beneficiares_deces.map(beneficiaire => beneficiaire.id);
          }

          this.pjOk = pj.is_pj_ok;

          this.$refs['modal-modify-pj'].show();
        }

      },
      initPeriodes(pj, typePeriode, typeAnnee, libelleTechnique, typeToShow, typeRessource) {
        for (let type of pj.types_pj) {
          if (libelleTechnique.indexOf(type.libelle_technique) > -1) {
            for (let periode of type.periodes) {
              if (!isEmpty(periode.date_debut) || !isEmpty(periode.is_not_available)) {
                this[typePeriode].push({id: periode.id, date_debut: periode.date_debut, date_fin: periode.date_fin, is_not_available: periode.is_not_available});
              } else {
                this[typeAnnee].push({id: periode.id, annee: periode.annee, is_not_available: periode.is_not_available});
              }
            }
            this[typeToShow] = true;
            // On regarde si on est dans le cas d'une attestation de ressource, si oui on regarde si une valeur a déjà été enregistrée
            if (!isEmpty(typeRessource)) {
              this[typeRessource] = this.dossier.inval ? this.dossier.inval.attestation_ressource : ''
            }
          }
        }
        // Si periodesBs est vide on crée les infos vides pourl'affichage des champs vierge
        if (isEmpty(this[typePeriode])) {
          this[typePeriode].push({id: null, date_debut: '', date_fin: '', is_not_available: null});
        }
        if (isEmpty(this[typeAnnee])) {
          this[typeAnnee].push({id: null, annee: '', is_not_available: null});
        }
      },
      initPeriodeAvisImpot(pj) {
        for (let type of pj.types_pj) {
          if (['avis_imposition_inval', 'avis_imposition_dc'].indexOf(type.libelle_technique) > -1) {
            for (let periode of type.periodes) {
              this.periodeAvisImpot.push({id: periode.id, annee: periode.annee, revenu_fiscal: periode.revenu_fiscal, nombre_parts: periode.nombre_parts, is_not_available: periode.is_not_available, is_not_available_revenu_fiscal: periode.is_not_available_revenu_fiscal, is_not_available_nombre_parts: periode.is_not_available_nombre_parts})
            }
            this.showPeriodeAvisImpot = true;
          }
        }
        // Si periodesBs est vide on crée les infos vides pourl'affichage des champs vierge
        if (isEmpty(this.periodeAvisImpot)) {
          this.periodeAvisImpot.push({id: null, annee: null, revenu_fiscal: null, nombre_parts: null, is_not_available: null, is_not_available_revenu_fiscal: null, is_not_available_nombre_parts: null})
        }
      },
      getTypeDossier() {
        let type = null;
        if (!isEmpty(this.dossier.type)) {
          type = this.dossier.type;
        } else if (!isEmpty(this.$parent.$parent.$parent.selectedType)) {
          type = this.$parent.$parent.$parent.allTypes.find(type => type.id === parseInt(this.$parent.$parent.$parent.selectedType,10))

        }
        return type;
      },
      modifyPj() {
        this.clearErrors()
        if (this.validateModifyPj()) {
          // console.log('dans le save : ',this.periodesBs)
          let self = this;
          let periodes = {};
          periodes = this.preparePeriode()
          for (const periode in periodes) {
            // console.log(periodes[periode])
            // console.log(periodes[periode].periodes[0]['is_not_available'])
            if (periodes[periode].periodes[0]['is_not_available']) {
              periodes[periode].periodes = []
            }
          }
          let dataPost = {
            pjId : this.pjToRename.id,
            name: this.newFilename,
            typesId: this.typesId,
            // typeSecondaire: this.selectedTypeSecondaire,
            beneficiaires_id: this.beneficiairesId,
            periodes: periodes,
            is_pj_ok: this.pjOk,
            description: this.description,
          }
          if (!isEmpty(this.typeAttestationRessource)) {
            this.$event.emit('updateAttestationRessource', this.typeAttestationRessource)
          }
          // console.log('dataPost', dataPost)
          // console.log('this.typeAttestationRessource', this.typeAttestationRessource)
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post("/espaceGestion/dossier-pieces-jointes/modify",dataPost)
            .then(async response => {
              this.$store.commit('IS_LOADING', false)
              // this.$event.emit('refreshDossier');
              await this.getPiecesJointes();
              if (dataPost.is_pj_ok === true || dataPost.is_pj_ok === false) {
                this.$event.emit('pjOk',{isPjOk: dataPost.is_pj_ok, pjId: dataPost['pjId'], typesId: dataPost['typesId'], beneficiairesIds: dataPost['beneficiaires_id'], allTypes: this.allTypes});
              }
              // On envoi un event pour la partie bénéficiaire afin de pouvoir faire le test sur les pj rattaché lors de la suppression d'un bénéficaire
              this.$event.emit('changementPj',this.piecesJointes);
              this.closeModifyPjModal();
            })
            .catch(function(error){
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
            });
        }
      },
      validateModifyPj() {
        // console.log('this.typeBs',this.typeBs)
        let valid = true;
        let invalidCaracter = new RegExp(/[&@:/\\]+/);
        if (invalidCaracter.test(this.newFilename.trim())) {
          valid = false;
          this.errors.newFilename = 'Les charactères &@:/\\ sont interdis.'
        }
        // console.log(invalidCaracter.test(this.newFilename.trim()))
        if (this.newFilename.trim() === '') {
          this.newFilename = 'Sans nom';
        }
        if (isEmpty(this.typesId) && this.$parent.$parent.$parent.isQualification) {
          valid = false;
          this.errors.typeDocument = 'Veuillez choisir un type de document';
        } else {
          // On regarde si les périodes sont bien renseignées pour les documents où l'information est obligatoire pour le PFE
          let actualType = this.getTypeDossier();
          if (actualType.groupe.toLowerCase() === 'inval') {
            for (let typeId of this.typesId) {
              if (this.typeBsIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodesBs, 'periode') && this.isEmptyPeriode(this.anneeBs, 'annee')) {
                valid = false;
                this.errors.periodesBs = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeDecompteIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodesDecompte, 'periode') && this.isEmptyPeriode(this.anneeDecompte, 'annee')) {
                valid = false;
                this.errors.periodesDecompte = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeAttestationRessourceIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeAttestationRessource, 'periode') && this.isEmptyPeriode(this.anneeAttestationRessource, 'annee')) {
                valid = false;
                this.errors.periodeAttestationRessource = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeDecomptePoleEmploiIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeDecomptePoleEmploi, 'periode') && this.isEmptyPeriode(this.anneeDecomptePoleEmploi, 'annee')) {
                valid = false;
                this.errors.periodeDecomptePoleEmploi = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationRetraiteIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationRetraite, 'periode') && this.isEmptyPeriode(this.anneeNotificationRetraite, 'annee')) {
                valid = false;
                this.errors.periodeNotificationRetraite = 'vous devez saisir une période ou coché la case "Information non présente ou illisible"';
              }
              if (this.typeDeclarationCAIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeDeclarationCA, 'periode') && this.isEmptyPeriode(this.anneeDeclarationCA, 'annee')) {
                valid = false;
                this.errors.periodeDeclarationCA = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeExtraitBancaireSSIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeExtraitBancaireSS, 'periode') && this.isEmptyPeriode(this.anneeExtraitBancaireSS, 'annee')) {
                valid = false;
                this.errors.periodeExtraitBancaireSS = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeExtraitBancaireAutreOrgIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeExtraitBancaireAutreOrg, 'periode') && this.isEmptyPeriode(this.anneeExtraitBancaireAutreOrg, 'annee')) {
                valid = false;
                this.errors.periodeExtraitBancaireAutreOrg = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationPoleEmploiIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationPoleEmploi, 'periode') && this.isEmptyPeriode(this.anneeNotificationPoleEmploi, 'annee')) {
                valid = false;
                this.errors.periodeNotificationPoleEmploi = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeCertificatTravailIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeCertificatTravail, 'periode') && this.isEmptyPeriode(this.anneeCertificatTravail, 'annee')) {
                valid = false;
                this.errors.periodeCertificatTravail = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationRenteIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationRente, 'periode') && this.isEmptyPeriode(this.anneeNotificationRente, 'annee')) {
                valid = false;
                this.errors.periodeNotificationRente = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationRevRenteSSIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationRevRenteSS, 'periode') && this.isEmptyPeriode(this.anneeNotificationRevRenteSS, 'annee')) {
                valid = false;
                this.errors.periodeNotificationRevRenteSS = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationDecesIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationDeces, 'periode') && this.isEmptyPeriode(this.anneeNotificationDeces, 'annee')) {
                valid = false;
                this.errors.periodeNotificationDeces = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeNotificationsuspensionRenteSSIds.indexOf(typeId) > -1 && this.isEmptyPeriode(this.periodeNotificationsuspensionRenteSS, 'periode') && this.isEmptyPeriode(this.anneeNotificationsuspensionRenteSS, 'annee')) {
                valid = false;
                this.errors.periodeNotificationsuspensionRenteSS = 'vous devez saisir une période ou cocher la case "Information non présente ou illisible"';
              }
              if (this.typeAvisImpositionIds.indexOf(typeId) > -1) {
                if (this.isEmptyAvisImpot()) {
                  valid = false;
                  this.errors.periodeAvisImpot = 'vous devez saisir les années et nombre de parts ou cocher les cases "Information non présente ou illisible".';
                }
                if (!isEmpty(this.periodeAvisImpot.nombre_parts) && parseFloat(this.periodeAvisImpot.nombre_parts) > 99.99) {
                  let nbParts = parseFloat(this.periodeAvisImpot.nombre_parts);
                  valid = false;
                  this.errors.periodeAvisImpot = this.errors.periodeAvisImpot + ' Le nombre de parts indiqué n\'est pas valide';
                }
              }
            }
          }
        }

        return valid;
      },
      isEmptyPeriode(data, type) {
        let dataEmpty = true;
        // console.log('isEmptyPeriode(data, type) => data', data)
        if (type === 'periode') {
          for (let row of data) {
            if ((!isEmpty(row.date_debut) && !isEmpty(row.date_fin)) || row.is_not_available) {
              dataEmpty = false;
              break;
            }
          }
        }

        if (type === 'annee') {
          for (let row of data) {
            if (!isEmpty(row.annee) || row.is_not_available) {
              dataEmpty = false;
              break;
            }
          }
        }

        return dataEmpty;
      },
      isEmptyAvisImpot() {
        let hasCritereEmpty = false;
        for (let avis of this.periodeAvisImpot) {
          // console.log('avis',avis)
          if (!((isEmpty(avis.annee) && (isEmpty(avis.is_not_available) || avis.is_not_available === false)) && (isEmpty(avis.revenu_fiscal) && (isEmpty(avis.is_not_available_revenu_fiscal) || avis.is_not_available_revenu_fiscal === false)) && (isEmpty(avis.nombre_parts) && (isEmpty(avis.is_not_available_nombre_parts) || avis.is_not_available_nombre_parts === false)))) {
            if ((isEmpty(avis.annee) && (isEmpty(avis.is_not_available) ||  avis.is_not_available === false)) || (isEmpty(avis.revenu_fiscal) && (isEmpty(avis.is_not_available_revenu_fiscal) || avis.is_not_available_revenu_fiscal === false)) || (isEmpty(avis.nombre_parts) && (isEmpty(avis.is_not_available_nombre_parts) || avis.is_not_available_nombre_parts === false))) {
              hasCritereEmpty = true;
            }
          }
        }
        // console.log('isEmptyAvisImpot',(isEmpty(this.periodeAvisImpot.annee) && isEmpty(this.periodeAvisImpot.is_not_available)) || (isEmpty(this.periodeAvisImpot.revenu_fiscal) && isEmpty(this.periodeAvisImpot.is_not_available_revenu_fiscal)) || (isEmpty(this.periodeAvisImpot.nombre_parts) && isEmpty(this.periodeAvisImpot.is_not_available_nombre_parts)))
        return hasCritereEmpty;
      },
      preparePeriode() {
        let response = {};
        for (let typeId of this.typesId) {
          if (this.typeBsIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodesBs.concat(this.anneeBs)};
          } else if (this.typeDecompteIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodesDecompte.concat(this.anneeDecompte)};
          } else if (this.typeAvisImpositionIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeAvisImpot};
          } else if (this.typeAttestationRessourceIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeAttestationRessource.concat(this.anneeAttestationRessource)};
          } else if (this.typeDecomptePoleEmploiIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeDecomptePoleEmploi.concat(this.anneeDecomptePoleEmploi)};
          } else if (this.typeNotificationRetraiteIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationRetraite.concat(this.anneeNotificationRetraite)};
          } else if (this.typeDeclarationCAIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeDeclarationCA.concat(this.anneeDeclarationCA)};
          } else if (this.typeExtraitBancaireSSIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeExtraitBancaireSS.concat(this.anneeExtraitBancaireSS)};
          } else if (this.typeExtraitBancaireAutreOrgIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeExtraitBancaireAutreOrg.concat(this.anneeExtraitBancaireAutreOrg)};
          } else if (this.typeNotificationPoleEmploiIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationPoleEmploi.concat(this.anneeNotificationPoleEmploi)};
          } else if (this.typeCertificatTravailIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeCertificatTravail.concat(this.anneeCertificatTravail)};
          } else if (this.typeNotificationRenteIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationRente.concat(this.anneeNotificationRente)};
          } else if (this.typeNotificationRevRenteSSIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationRevRenteSS.concat(this.anneeNotificationRevRenteSS)};
          } else if (this.typeNotificationDecesIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationDeces.concat(this.anneeNotificationDeces)};
          } else if (this.typeNotificationsuspensionRenteSSIds.indexOf(typeId) > -1) {
            response[typeId] = {periodes: this.periodeNotificationsuspensionRenteSS.concat(this.anneeNotificationsuspensionRenteSS)};
          }
        }

        return response;
      },
      closeModifyPjModal() {
        this.errors.newFilename = '';
        this.newFilename = '';
        this.pjToRename = {};
        this.clearForm();
        this.$refs['modal-modify-pj'].hide();
      },
      getPjDossierId(pj) {
        if (pj.dossier_source_id) {
          return pj.dossier_source_id;
        } else {
          if (pj.source === 'gestionnaire' || pj.source === 'mail') {
            return pj.dossier_id;
          } else {
            return pj.source_id ? pj.source_id : pj.dossier_id;
          }
        }
      },
      getCategorie(pj) {
        // console.log('pj',pj)
        // let textSecondaire = pj.type_secondaire ? (pj.type_secondaire.libelle.length > 30 ? pj.type_secondaire.libelle.substring(0,27)+'...' : pj.type_secondaire.libelle) : '';
        // let text = pj.type_principale ? (textSecondaire !== '' ? pj.type_principale.libelle + ' - ' + textSecondaire : pj.type_principale.libelle) : '';
        let text = '';
        for (let type of pj.types_pj) {
          text = text + ', ' + type.libelle;
        }
        text.trim();
        text = text.replace(/^, /, '');
        // console.log('dans getCategorie : ', pj.name)
        // text = text.length > 12 ? text.substring(0,9) + '...' : text;
        // console.log('text',text)
        return text;
      },
      canReply(mail) {
        const reg = /[0-9]{8,14}-[0-9]*-DPC-[0-9]*/;
        return reg.test(mail.subject);
      },
      repondre(mail) {
        // console.log(mail)
        this.mailReponse = mail;
        this.reponseTo = mail.mail_from;
        this.reponseCc = mail.mail_cc;
        this.reponseSubject = 'Re : ' + mail.subject;
        this.reponseBody = '&nbsp;<br><br>----------------------- Message d\'origine -----------------------<br>' + nl2br(mail.body_text);
        this.$refs['modal-mail-dpc'].show();
      },
      sendReponse() {
        let self = this
        let formData = new FormData();
        for( var i = 0; i < this.dpcAttachments.length; i++ ){
            let file = this.dpcAttachments[i];
            // console.log(file);
            formData.append('files[' + i + ']', file)
        }
        formData.append('type_dpc', 'mail')
        formData.append('traitement_id', this.$route.query.traitementId)
        formData.append('mail_to', this.reponseTo)
        formData.append('mail_subject', this.reponseSubject)
        formData.append('mail_body', this.reponseBody)
        formData.append('mail_cc', this.reponseCc)
        formData.append('dossier_id', this.dossier.id)
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/incidents/dpc/reply', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then((response) => {
            this.$store.commit('IS_LOADING', false)
            const mailTo = this.reponseTo

            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Mail correctement envoyé',
              text: 'Le mail a bien été envoyé à ' + mailTo,
              showConfirmButton: false,
              timer: 5000
            });
            this.$event.emit('refreshDossier');
            this.closeReponseMailModal();
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
              console.log('error',error)
              let errorText = 'Une erreur est survenue lors de l\'envoie du mail. Si le problème persiste, merci de faire un ticket au support DOSI.'
              if (error.response && error.response.status === 424) { errorText = error.response.data.message }
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      addFileToDpc(event) {
        this.dpcAttachments = event.target.files
        // console.log(this.dpcAttachments)
      },
      formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} fichiers selectionnés`
        }
      },
      downloadDpcPj(pj) {
        let self = this;
        let fileNameArr = pj.name.split('.')
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        this.$axios
          .get("/espaceGestion/dossier-pieces-jointes/download/"+pj.id, {responseType: 'arraybuffer'})
          .then(response => {
            // console.log(response)
            downloadFile(response, name, ext);
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue lors de la récupération de la pièce jointe, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      },
      canDeleteDpcPj() {
        return this.mailReponse.is_sent === false;
      },
      deleteDpcPj(pj) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer cette pièce jointe ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              let self = this;
              let data = {};
              data.traitementId = this.$route.query.traitementId;

              this.$store.commit("IS_LOADING", true);

              this.$axios
                .post("/espaceGestion/dossier-pieces-jointes/delete/"+pj.id,data)
                .then(response => {
                  this.$store.commit("IS_LOADING", false);
                  let dpcAttachmentsUploaded = [...this.dpcAttachmentsUploaded]
                  this.dpcAttachmentsUploaded = []
                  for (let oldPj of dpcAttachmentsUploaded) {
                    if (oldPj.id !== pj.id) {
                      this.dpcAttachmentsUploaded.push(oldPj)
                    }
                  }
                  this.manageChange()
                  this.$swal(
                    {
                      position: 'top',
                      type: 'success',
                      title: 'Suppression',
                      text: 'La pièce jointe a été correctement supprimée.',
                      showConfirmButton: false,
                      timer: 5000
                    })
                })
                .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  self.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })
      },
      closeReponseMailModal() {
        this.dpcAttachments = [];
        this.mailReponse = {};
        this.reponseTo = '';
        this.reponseCc = '';
        this.reponseSubject = '';
        this.reponseBody = '';
        this.$refs['modal-mail-dpc'].hide();
      },
      getformattedDateTime(textDate) {
        return formatDateTime(textDate, '/');
      },
      getPiecesJointes() {
        return new Promise (resolve => {
          let self = this;
          this.$axios
            .get("/espaceGestion/dossier-pieces-jointes/dossier/"+this.dossier.id)
            .then(response => {
              this.piecesJointes = response.data.pjs;
              for (let pj of response.data.pjs) {
                this.categoriePj[pj.id] = this.getCategorie(pj);
              }
              this.$event.emit('refreshPjs', response.data.pjs)
              resolve();
            })
            .catch(function(error){
              console.log(error)
              // self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000});
              resolve();
            });
        });
      },
      getTooltipName(pj) {
        let response = '';

        for (let type of pj.types_pj) {
          response = response + type.libelle;
          if (!isEmpty(type.periodes)) {
            response = response + ' : ';
            for (let periode of type.periodes) {
              let text = '';
              if (!isEmpty(periode.date_debut)) {
                text = 'du ' + this.shortFormatDate(periode.date_debut) + ' au ' + this.shortFormatDate(periode.date_fin);
              } else if (!isEmpty(periode.annee) || !isEmpty(periode.revenu_fiscal) || !isEmpty(periode.nombre_parts) || !isEmpty(periode.is_not_available_revenu_fiscal) || !isEmpty(periode.is_not_available_nombre_parts)) {
                text = !isEmpty(periode.annee) ? 'année '+periode.annee : (!isEmpty(periode.is_not_available) ? 'année non disponible' : 'année non renseignée');
                if (!isEmpty(periode.revenu_fiscal) || !isEmpty(periode.is_not_available_revenu_fiscal)) {
                  text = !isEmpty(periode.revenu_fiscal) ? text + ', revenu fiscal '+periode.revenu_fiscal : (!isEmpty(periode.is_not_available_revenu_fiscal) ? text+', revenu fiscal non disponible' : text+', revenu fiscal non renseignée');
                }
                if (!isEmpty(periode.nombre_parts) || !isEmpty(periode.is_not_available_nombre_parts)) {
                  text = !isEmpty(periode.nombre_parts) ? text + ', nombre de parts '+periode.nombre_parts : (!isEmpty(periode.is_not_available_nombre_parts) ? text+', nombre de parts non disponible' : text+', nombre de parts non renseignée');
                }
              } else if (!isEmpty(periode.is_not_available)) {
                text = 'information non disponible ou illisible'
              };
              response = response + text + ', ';
            }
            response = response.replace(/, $/, '');
          }
          response = response + '<br>';
        }
        if (!isEmpty(pj.beneficiares_deces)) {
          response = response + 'Beneficiaires : ';
          for (let beneficiaire of pj.beneficiares_deces) {
            response = response + beneficiaire.prenom + ' ' + beneficiaire.nom + ', ';
          }
          response = response.replace(/, $/, '');
        }
        // console.log('response',response)
        return response.trimRight('<br>');
      },
      openPjs() {
        let self = this;
        let ext = 'pdf';
        let name = 'multiples_documents';
        let dataPost = {pjIds: this.selectedPjs};
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceGestion/dossier-pieces-jointes/download/multi",dataPost, {responseType: 'blob'})
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            downloadFile(response, name, ext);
          })
          .catch((error) => {
            this.$store.commit("IS_LOADING", false);
            console.log(error)
            console.log(error.response)
            let text = "Une erreur est survenue lors de la récupération des pièces jointes, si le problème persiste merci de faire un ticket au support DOSI";
            // if (error.response && error.response.status === 424) {
            //     text = 'Un des PDF sélectionnés n\'est pas compatible avec la visualisation multiple de document? Malheureusement nous ne pouvons pas vous dire lequel (probablement un PDF Chorum).';
            // }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: text,
              showConfirmButton: false,
              timer: 5000
            });
          })
      },
      setPjsInutiles() {
        let self = this;
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous qualifier ces pièces jointes en inutiles ?",
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Continuer',
            cancelButtonText: 'Annuler',
          })
          .then(async (result) => {
            if (result.value) {
              let dataPost = {pjIds: this.selectedPjs};
              this.$axios
                .post("/espaceGestion/dossier-pieces-jointes/inutile", dataPost)
                .then(response => {
                  this.$swal({ position: 'top', type: 'success', title:'Succès !!', text:'Les pjs ont été correctement qualifiées.',showConfirmButton: false, timer: 5000});
                  this.selectedPjs = [];
                  this.getPiecesJointes();
                })
                .catch(function(error){
                  console.log(error)
                  // self.$store.commit('IS_LOADING', false)
                  self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000});
                });
            }
          });
      },
      cantEditFicheDC
    }
  }
</script>
<style scoped>
  .pj-bloc {
    /*border-style: inset;
    border-width: thin;*/
    padding: 3px;
  }

  .pj-bloc-interne {
    border-left: thin solid #EBEBEB;
  }

  .table-wrapper {
    position: relative;
  }

  .table-scroll {
    overflow: auto;
    margin-top: 80px;
  }
  a:visited {
    color: violet;
  }
</style>
<style type="text/css">
  .table-pj th, .table-pj td {
    padding: 0.50rem 0.40rem;
  }
  .table-pj .btn-sm, .btn-group-sm > .btn {
    padding: 0.15rem 0.25rem;
    font-size: 0.76562rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }
  .ck.ck-content.ck-editor__editable p {
    white-space: pre-line;
  }

  .libelle-max-width {
    max-width: 353px;
  }
  /* .dossier-width {
    width: 100px;
  }
  .date-width {
    width: 85px;
  }
  .categorie-width {
    width: 115px;
  }
  .visu-width {
    width: 65px;
  }
  .action-width {
    width: 70px
  } */
</style>
